// extracted by mini-css-extract-plugin
export default {"scrollable":"ScrollableComponent_scrollable__a27Yc"};